import { useRouter } from "next/router";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { formatAmountPutComma } from "@/utils/utils";
import { Zap } from "lucide-react";

function PoojaPackageComponent({
  openModal,
  packageData,
  packageName,
  onBookNow,
  onAddToCart,
  poojaId,
  packageId,
  packageType,
}) {
  const router = useRouter();

  return (
    <div className="mx-2 relative">
      <div className="flex flex-row z-10 justify-center w-full absolute -top-5 h-24">
        <ImageWrapper
          src="/icons/Group6903.svg"
          alt="Line design"
          width={112}
          height={48}
          className="object-contain"
        />
      </div>

      <div
        className={`w-[260px] pb-4 border border-red-100 flex-none shadow-lg px-3 rounded-md ${packageName === "Basic"
          ? "bg-orange-50"
          : packageName === "Standard"
            ? "bg-red-50"
            : packageName === "Premium"
              ? "bg-red-100"
              : ""
          } overflow-hidden relative`}
      >
        <div className="relative w-20 h-12 absolute -top-7 -right-9 overflow-hidden">
          <ImageWrapper
            src="/icons/Group6334.svg"
            alt="Design image"
            fill
            className="object-cover"
          />
        </div>

        <div className="pt-0">
          <div className="flex items-center justify-between text-sm font-lato border-b border-dashed pb-1">
            <span className="text-gray-700 tracking-wide">
              {packageName}
            </span>

            <span className="text-BluntRed font-bold text-base">
              ₹ {packageData.price
                ? formatAmountPutComma(packageData.price)
                : "On Request"}
            </span>
          </div>
        </div>

        <div className="flex flex-col text-Default gap-4 pt-6 pb-4 text-sm font-base md:leading-5 tracking-normal">
          {packageData.inclusions &&
            packageData.inclusions.length > 0 &&
            packageData.inclusions.map((item, key) => (
              <div className="flex flex-row justify-between" key={key}>
                <p className="flex flex-row">{item.name}</p>
                <div className="flex-shrink-0 w-5 h-5">
                  {!Object.keys(item).includes("present") || (item.present && item.present === true) ? (
                    <ImageWrapper src="/icons/tick.svg" alt="Included" width={20} height={20} />
                  ) : (
                    <ImageWrapper src="/icons/cross.svg" alt="Not included" width={20} height={20} />
                  )}
                </div>
              </div>
            ))}

          <div className="flex flex-row justify-between">
            <p>Number Of Days</p>
            <div>{packageData.numberOfDays ? packageData.numberOfDays : ""}</div>
          </div>
          <div className="flex flex-row justify-between">
            <p>Number Of Pandits</p>
            <div>{packageData.numberOfPandits ? packageData.numberOfPandits : ""}</div>
          </div>
        </div>

        <hr />

        {/* Know More */}
        <div
          onClick={() => openModal(packageData, packageName)}
          className="flex flex-row mt-2 justify-end items-center text-center px-1"
        >
          <button className="text-BluntRed pr-2 font-medium text-xs md:leading-4 cursor-pointer">
            Know More
          </button>
          <p className="w-4 h-4 relative">
            <ImageWrapper
              src="/icons/knowMoreArrow.svg"
              alt="Right arrow"
              className="cursor-pointer object-cover"
            />
          </p>
        </div>

        {/* ── TWO ACTION BUTTONS ── */}
        <div className="flex flex-col gap-2 mt-3">
          {/* Quick Checkout — primary CTA */}
          <button
            type="button"
            className="w-full py-3 rounded-md bg-BluntRed text-white text-sm font-semibold 
  flex items-center justify-center gap-2 
  shadow-lg hover:shadow-xl 
  hover:scale-[1.02] active:scale-[0.98] 
  transition-all duration-200 relative overflow-hidden"
            onClick={() =>
              onBookNow && onBookNow(poojaId, packageId, packageType, packageData)
            }
          >
            {/* Pulse effect */}
            <span className="absolute inset-0 animate-ping bg-red-800 opacity-20 rounded-md"></span>

            <Zap size={16} className="animate-bounce" />
            <span className="relative z-10">Book Now</span>
          </button>

          {/* Add to Cart — secondary */}
          <button
            type="button"
            className="hidden w-full py-2.5 rounded-md 
  border border-gray-300 text-gray-500 text-sm font-medium 
  hover:bg-gray-100 hover:text-gray-700 
  transition-colors duration-200"
            onClick={() => {
              document.body.style.overflow = "auto";
              if (onAddToCart) onAddToCart({ poojaId, packageId, packageType });
            }}
          >
            🛒 Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default PoojaPackageComponent;
